import Configs from "../config";
import { DefaultResponse } from "../types/UtilTypes";
import { localStorageGetItem } from "../utils/LocalStorage";

interface GetProductsResponse {
  name: string;
  id: string;
}

export const getProducts = async (): Promise<GetProductsResponse[]> => {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/stripe/products`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  });

  const responseJSON: DefaultResponse<GetProductsResponse[]> =
    await response.json();
  if (responseJSON.status === "ok") {
    return responseJSON.data;
  }

  throw new Error(responseJSON.code);
};

export const StripeAPI = {
  getProducts,
};
